import { format } from 'date-fns'

export function formatDateToString(parameterDate?: string | Date, useTimezone = true, defaultEmptyString = '') {
  if (!parameterDate) return defaultEmptyString

  if (useTimezone) {
    return format(new Date(parameterDate), 'dd/MM/yyyy')
  }

  const dateToString = parameterDate.toString()

  const split1 = dateToString.split('T')

  const split2 = split1[0].split('-')

  const [year, month, day] = split2

  return `${day}/${month}/${year}`
}
